module.exports = __webpack_public_path__ + "static/media/bridgewater.17eb0f52.png";